import {Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-card',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-card sd-card block rounded-xl border border-[var(--m365-border-rest,#ececf0)] bg-white p-4 shadow-sm'},
})
export class SdCard {}

@Component({
  selector: 'sd-card-title',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'block text-base font-semibold'},
})
export class SdCardTitle {}

@Component({
  selector: 'sd-card-subtitle',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'block text-sm text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdCardSubtitle {}

@Component({
  selector: 'sd-card-header',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'mb-3 block'},
})
export class SdCardHeader {}

@Component({
  selector: 'sd-card-content',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'block text-sm'},
})
export class SdCardContent {}

@Component({
  selector: 'sd-card-actions',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'mt-3 flex flex-wrap gap-2'},
})
export class SdCardActions {
  @Input() align: string | undefined;
}

@NgModule({
  imports: [SdCard, SdCardTitle, SdCardSubtitle, SdCardHeader, SdCardContent, SdCardActions],
  exports: [SdCard, SdCardTitle, SdCardSubtitle, SdCardHeader, SdCardContent, SdCardActions],
})
export class SdCardModule {}
